import React from 'react';
import Icon from 'components/AppIcon';

const OrderStats = ({ openOrders, orderHistory }) => {
  const stats = [
    {
      label: 'Open Orders',
      value: openOrders.length,
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning-50'
    },
    {
      label: 'Filled Today',
      value: orderHistory.filter(order => 
        order.status === 'filled' && 
        order.timestamp > new Date(Date.now() - 86400000)
      ).length,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success-50'
    },
    {
      label: 'Partial Fills',
      value: openOrders.filter(order => order.status === 'partial').length,
      icon: 'PieChart',
      color: 'text-primary',
      bgColor: 'bg-primary-50'
    },
    {
      label: 'Total Volume',
      value: `$${(openOrders.reduce((sum, order) => sum + order.total, 0) + 
        orderHistory.reduce((sum, order) => sum + order.total, 0)).toLocaleString()}`,
      icon: 'TrendingUp',
      color: 'text-accent',
      bgColor: 'bg-accent-50'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {stats.map((stat, index) => (
        <div key={index} className="bg-surface rounded-trading border border-border p-6 shadow-trading-card">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-text-secondary font-body-normal text-sm mb-1">{stat.label}</p>
              <p className="text-2xl font-heading-bold text-text-primary">{stat.value}</p>
            </div>
            <div className={`w-12 h-12 ${stat.bgColor} rounded-trading flex items-center justify-center`}>
              <Icon name={stat.icon} size={24} className={stat.color} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OrderStats;